import './sparkButton.css';
import { FunctionComponent } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { getGameState } from '../../redux/slices/game.slice';
import { CJRButton } from '../cjrButton/cjrButton';

export const SparkButton: FunctionComponent<any> = ({ children, ...props }) => {
  const { turnPhase } = useAppSelector(getGameState);

  return (
    <CJRButton
      ref={props.forwardedRef}
      style={{
        animation: turnPhase == 'score' ? 'pulse 0.5s 6' : '',
        width: '100%',
        maxWidth: '200px',
      }}
      variant="sparkPrimary"
      {...props}
    >
      {children}
    </CJRButton>
  );
};
